"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buttonTypes = exports.buttonSizes = void 0;
var buttonSizes = {
  TINY: 'tiny',
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
};
exports.buttonSizes = buttonSizes;
var buttonTypes = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  GHOST_LIGHT: 'ghost-light',
  GHOST_DARK: 'ghost-dark',
  STANDALONE_WHITE: 'standalone-white',
  STANDALONE: 'standalone',
  TRANSPARENT_LIGHT: 'transparent-light',
  TRANSPARENT_DARK: 'transparent-dark'
};
exports.buttonTypes = buttonTypes;